import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import ContactService from "../Services/contact.service";
import "./requestdemo.css";

import AOS from "aos";
import "aos/dist/aos.css";

function RequestDemo() {
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);
  const [userDetails, setUserDetails] = useState({
    name: "",
    phone: "",
    email: "",
    companyName: "",
    jobTitle: "",
    companySize: "",
    country: "",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init();
  }, []);

  const handleShow = () => setShow(true);

  const handleClose = () => setShow(false);

  const navigate = useNavigate();

  const required = (value) => {
    if (!value) {
      return (
        <div className="alert alert-danger" role="alert">
          This field is required!
        </div>
      );
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setUserDetails({ ...userDetails, [name]: value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      toast("*Please fill all required fields!", {
        // position: "top-center",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      return;
    }

    setValidated(true);
    event.preventDefault();
    if (validated) {
      ContactService.submitRequestDemoData(userDetails)
        .then((response) => {
          // console.log(response.data);
          if (response.data === true) {
            handleShow();
          }
        })
        .catch((error) => {
          console.error("There was a problem with the fetch operation:", error);
        });
    }
  };

  return (
    <>
      <div className="requestdemo-banner">
        <div className="container-fluid">
          <div className="requestdemo-content">
            <div className="heading"   data-aos="fade-up"
                data-aos-duration="1500">
              <div className="heading-flex">
                <h2>Request Demo</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="about-section">
        <div className="after-banner-circle"></div>
        <div className="about-section-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                <Form
                  noValidate
                  validated={validated}
                  onSubmit={handleSubmit}
                  className="contact-form"
                    data-aos="fade-up"
                data-aos-duration="1500"
                  // ref={form}
                >
                  <Form.Group className="contact-form-group mb-3">
                    <Form.Label className="form-label">Name*</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Enter your name.."
                      value={userDetails.name}
                      onChange={handleChange}
                      required
                      className="input-field abc"
                      validations={[required]}
                    />
                  </Form.Group>
                  <div className="form-name">
                    <Form.Group className="contact-form-group mb-3">
                      <Form.Label className="form-label">
                        Phone Number*
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="phone"
                        placeholder="Enter your phone number.."
                        value={userDetails.phone}
                        onChange={handleChange}
                        required
                        className="input-field abc"
                        validations={[required]}
                      />
                    </Form.Group>

                    <Form.Group className="contact-form-group mb-3">
                      <Form.Label className="form-label">Email*</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        placeholder="Enter your email.."
                        value={userDetails.email}
                        onChange={handleChange}
                        required
                        className="input-field abc"
                        validations={[required]}
                      />
                    </Form.Group>
                  </div>
                  <Form.Group className="contact-form-group mb-3">
                    <Form.Label className="form-label">
                      Company Name*
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="companyName"
                      placeholder="Enter company name.."
                      value={userDetails.companyName}
                      onChange={handleChange}
                      required
                      className="input-field"
                      validations={[required]}
                    />
                  </Form.Group>
                  <Form.Group className="contact-form-group mb-3">
                    <Form.Label className="form-label">Job Title</Form.Label>
                    <Form.Control
                      type="textbox"
                      name="jobTitle"
                      placeholder="Enter your job title.."
                      value={userDetails.jobTitle}
                      onChange={handleChange}
                      className="input-field"
                      // validations={[required]}
                    />
                  </Form.Group>
                  <Form.Group className="contact-form-group mb-3">
                    <Form.Label className="form-label">
                      Company Size (no. of employees)
                    </Form.Label>
                    <Form.Control
                      type="textbox"
                      name="companySize"
                      placeholder="Enter your company size.."
                      value={userDetails.companySize}
                      onChange={handleChange}
                      className="input-field"
                      // validations={[required]}
                    />
                  </Form.Group>
                  <Form.Group className="contact-form-group mb-3">
                    <Form.Label className="form-label">Country</Form.Label>
                    <Form.Control
                      type="textbox"
                      name="country"
                      placeholder="Enter country.."
                      value={userDetails.country}
                      onChange={handleChange}
                      className="input-field"
                      validations={[required]}
                    />
                  </Form.Group>

                  <button className="btn submit-btn">Submit</button>
                </Form>
              </div>
            </div>
          </div>
        </div>
        <Modal show={show} onHide={handleClose} centered>
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body className="thanks-modal">
            <p>Thank You for contacting us!</p>
            <span>We will get in touch with you soon.</span>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={() => {
                navigate("/");
                handleClose();
              }}
            >
              Okay
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}

export default RequestDemo;
